import { render, staticRenderFns } from "./ProductOrderConfirmationSentLogPopUp.vue?vue&type=template&id=410c1410&scoped=true&"
import script from "./ProductOrderConfirmationSentLogPopUp.vue?vue&type=script&lang=js&"
export * from "./ProductOrderConfirmationSentLogPopUp.vue?vue&type=script&lang=js&"
import style0 from "./ProductOrderConfirmationSentLogPopUp.vue?vue&type=style&index=0&id=410c1410&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410c1410",
  null
  
)

export default component.exports